export default "__VITE_ASSET__CDo3SeFw__"